import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';
import { dismissFailures, subscribeSaves } from 'utils/Axios/saveTracker';

const useStyles = makeStyles(() => ({
    root: {
        pointerEvents: 'auto',
        display: 'flex',
        alignItems: 'flex-start',
        gap: 8,
        padding: '8px 8px 8px 12px',
        borderRadius: 6,
        background: '#ffebee',
        border: '1px solid #ef9a9a',
        borderLeft: '5px solid #c62828',
        color: '#7f0000',
        fontSize: 14,
        boxShadow: '0 3px 10px rgba(0,0,0,0.25)',
    },
    text: { flex: 1 },
    title: { fontWeight: 700 },
    list: { margin: '2px 0 0', paddingLeft: 18 },
    hint: { fontSize: 12, marginTop: 2 },
    close: { color: '#7f0000', padding: 4 },
}));

const SHOWN = 3;

const time = date => date.toLocaleTimeString('uk-UA', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

/**
 * «НЕ ВНЕСЕНО» (organiser, 3 Nov 2026: «щоб секретар… бачив, що щось не
 * внеслося»): every write the server refused or never received — a point, a
 * penalty, a score, a winner, a setting — with its time and the server's
 * words, red at the top of the window until the same action is entered again
 * and saved, or the secretary closes the list. Nothing is re-sent from here.
 * Fed by saveTracker; not on a hall's screen.
 *
 * Stable hooks: failed-saves-bar, failed-saves-close.
 */
const FailedSavesBar = () => {
    const classes = useStyles();
    const [t] = useTranslation();
    const [failures, setFailures] = useState([]);

    useEffect(() => subscribeSaves(state => setFailures(state.failures || [])), []);

    if (0 === failures.length || /^\/display(\/|$)/.test(window.location.pathname)) {
        return null;
    }
    const latest = failures.slice(-SHOWN).reverse();

    return (
        <div className={classes.root} role='alert' data-testid='failed-saves-bar'>
            <div className={classes.text}>
                <div className={classes.title}>{`✗ ${t('saveStatus.notEntered', { count: failures.length })}`}</div>
                <ul className={classes.list}>
                    {latest.map(failure => (
                        <li key={`${failure.key}-${failure.at.getTime()}`}>
                            {time(failure.at)} — {failure.message ? t(failure.message, { defaultValue: failure.message }) : t('saveStatus.noConnection')}
                        </li>
                    ))}
                </ul>
                {failures.length > SHOWN && <div className={classes.hint}>{t('saveStatus.andMore', { count: failures.length - SHOWN })}</div>}
                <div className={classes.hint}>{t('saveStatus.enterAgain')}</div>
            </div>
            <IconButton className={classes.close} size='small' onClick={dismissFailures} aria-label={t('saveStatus.close')} data-testid='failed-saves-close'>
                <CloseIcon fontSize='small' />
            </IconButton>
        </div>
    );
};

export default FailedSavesBar;
